<template>
	<SOSlotBase
		:bg-grey="true"
		:loading="pageSetting.loading"
	>
		<template v-slot:loading-page>
			<SOLoadingPage/>
		</template>

		<template v-slot:title-bar>
			<SOTitleBar
				:page-title="'Layanan Snapclean Terfavorit'"
				:type="'back'"
				@back="back"
			/>
		</template>

		<template v-slot:content>
			<div class="p-x-20 p-y-16 bg-white">
				<div class="f-regular f-14 f-c-midgrey">
					Konsumen
				</div>
				<div class="f-bold f-18 f-c-black">
					{{ topFive.data.nama_konsumen }}
				</div>
				<div class="f-regular f-13 f-c-midgrey" v-if="topFive.data.rank_layanan.length > 0">
					Order sejak {{ topFive.data.transaksi_sejak }} • Total {{ topFive.data.total_layanan }} layanan
					digunakan
				</div>
				<div class="f-regular f-13 f-c-midgrey" v-else>
					{{ topFive.data.transaksi_sejak }}
				</div>
			</div>
			<div class="separator"></div>

			<SOCardCustomerGlobalTopFiveLayanan
				v-if="topFive.data.rank_layanan.length > 0"
				class="bg-white"
				:data="topFive.data.rank_layanan"
			/>

			<SOEmptyState v-if="topFive.data.rank_layanan.length === 0"/>
		</template>
	</SOSlotBase>
</template>

<script>
import {mapGetters} from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";

import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOCardCustomerGlobalTopFiveLayanan
	from "@/so-components/modules/customer-global/SOCardCustomerGlobalTopFiveLayanan";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";

export default {
	name: "CustomerGlobalTopFiveLayanan",
	components: {
		SOSlotBase,

		SOLoadingPage,
		SOTitleBar,
		SOCardCustomerGlobalTopFiveLayanan,
		SOEmptyState,
	},
	computed: {
		...mapGetters("customerGlobalModule", {
			topFive: "getTopFive"
		})
	},
	data() {
		return {
			idcustomer: "",
			pageSetting: {
				loading: true,
			}
		}
	},
	mounted() {
		this.idcustomer = this.$route.params.idcustomer
		this.getTopFive()
	},
	methods: {
		back() {
			// this.$router.push("/konsumen/snapclean/detail/" + this.idcustomer)
			this.$router.back()
		},
		async getTopFive() {
			this.pageSetting.loading = true
			const res = await this.$store.dispatch("customerGlobalModule/fetchTopFive", this.idcustomer)
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				this.back()
			}
		}
	}
}
</script>